import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Catálogo',
    path: '/catalogo/zonas',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ZonasPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Zonas</PageTitle>
      <View />
    </>
  );
};

export { ZonasPage };
